module.exports = __webpack_public_path__ + "img/tbq-video-thumbnail.2a3cd635.jpg";